export default "__VITE_ASSET__CcwbXKlx__"